import { connect } from 'react-redux';
import JadwalMapelGuru from '../../../views/Kurikulum/MataPelajaran/JadwalMapelGuru.view.js';
import {
  getParamOptionsAcademics, getClassesOptions, getPeriodsOptions, getPrmLevels, getSchoolUnitsOptions, getTeacherScheduleOptions,
  getDayOptions
} from '../../../states/thunks/options.thunk';
import {
  listScheduleTeacher, studentCount, reportSchPerunit, reportSchPerwakilan,
} from '../../../states/thunks/academics.thunk';

function mapStateToProps(state) {
  return {
    classes: state.options.classes,
    result: state.result,
    user: state.user || {},
  };
}

function mapDispatchToProps(dispatch) {
  return {
      handleStudentCount: payload => dispatch(studentCount(payload)),
      getClassesOptions: payload => dispatch(getClassesOptions(payload)),
      getParamOptionsAcademics: (payload, type) => dispatch(getParamOptionsAcademics(payload, type)),
      handleListScheduleTeacher: (payload, goback) => dispatch(listScheduleTeacher(payload, goback)),
      handleReportSchPerunit: (payload, goback) => dispatch(reportSchPerunit(payload, goback)),
      handleReportSchPerwakilan: (payload, goback) => dispatch(reportSchPerwakilan(payload, goback)),
      getPeriodsOptions: payload => dispatch(getPeriodsOptions(payload)),
      getPrmLevels: payload => dispatch(getPrmLevels(payload)),
      getDayOptions: payload => dispatch(getDayOptions(payload)),
      getSchoolUnitsOptions: payload => dispatch(getSchoolUnitsOptions(payload)),
      getTeacherScheduleOptions: payload => dispatch(getTeacherScheduleOptions(payload)),
  
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(JadwalMapelGuru);
